export default ({ axios, mapQueryString }) => ({
    index: (query = {}) => axios.get(`/providers${mapQueryString(query)}`)
})


// WEBPACK FOOTER //
// ./src/api/providers.js